// extracted by mini-css-extract-plugin
export default {"ctaButton":"CtaButton_ctaButton__GsEuD"};